<template>
  <BittsCallout
    v-if="typeof uniqueRecordCount === 'number'"
    :icon="['fad', 'file-export']"
    :title="title"
    type="neutral"
    size="x-small"
    class="unique-records-callout"
  >
    <template #right-item>
      <BittsButton
        class="bg-transparent ml-auto"
        @click="isRecordExportModalVisible = !isRecordExportModalVisible"
        type="primary"
        variant="outline"
        size="x-small"
        text="Learn more"
      />
    </template>
  </BittsCallout>
</template>

<script setup lang="ts">
import { BittsButton, BittsCallout } from '@crossbeam/bitts';

import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { usePopulationsStore } from '@/stores';
import type { Population, PopulationStats } from '@/types/populations';

const isRecordExportModalVisible = defineModel<boolean>();

const populationsStore = usePopulationsStore();
const { populations, uniqueRecordCount } = storeToRefs(populationsStore);

type PopulationWithMeta = Population & { meta?: PopulationStats };
const hasAtLeastOnePopulationComputing = computed(() =>
  populations.value.some(
    (pop: PopulationWithMeta) => pop.meta?.total_size === undefined,
  ),
);

const title = computed(() =>
  hasAtLeastOnePopulationComputing.value
    ? 'Calculating unique records...'
    : `Your populations include ${uniqueRecordCount.value?.toLocaleString()} unique records`,
);
</script>
